var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticStyle:{"background-color":"#EEE"},attrs:{"fluid":""}},[_c(_vm.pagina,{tag:"component",attrs:{"presupuesto":_vm.presupuesto,"origen":_vm.origen,"pLimitDate":_vm.dLimitDate},on:{"goToResum":_vm.fCargarPaginaResumen,"goToAsistente":_vm.fCargaPaginaAsistente,"loading":_vm.fLoading,"goToListado":_vm.fCargaPaginaListado,"alert":_vm.fAlert}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cced475c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Informes/Presupuestos/ShpInitPresupuestos.vue
// module id = null
// module chunks = 